import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../../services/util/error.service'
import * as ClientHttp from '../../../../../services/api/https/registration/client.http'
export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_ROUTE: 'Salvando rota de entrega',
  INITIAL_FETCH: 'Adquirindo rotas',
  SUCCESS: 'Rota atribuida',
}

const INITIAL_STATE = {
  rotas: undefined,
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  rotaSelecionada: null,
}

export default function useModalAssocDeliveryRoute() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      getRotasAssociadas(customerID, selectedTp) {
        ClientHttp.getAssocRotaEntregaCliente(customerID, selectedTp)
          .then(rotas =>
            setState(prevState => ({
              ...prevState,
              rotas: rotas,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      saveRotaEntrega(rotaID, customerID, selectedTp) {
        ClientHttp.saveAssocRotaEntregaCliente(rotaID, customerID, selectedTp)
          .then(rotas =>
            setState(prevState => ({
              ...prevState,
              rotas: rotas,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      resetState() {
        setState({ ...INITIAL_STATE })
      },

      clearError() {
        setState(prevState => ({ ...prevState, errorMessage: null }))
      },

      // Events
      onInit(customer) {
        if (customer) setState({ ...INITIAL_STATE, loadingMessage: LOAD_MESSAGE.INITIAL_FETCH })
      },

      onCheckboxClicked(rota, rotas) {
        if (rota) {
          setState(prevState => {
            const rotasAtualizadas = (prevState.rotas || rotas || []).map(r =>
              r.rota_id === rota.rota_id ? { ...r, selected: !r.selected } : r,
            )

            return {
              ...prevState,
              rotaSelecionada: null,
              rotas: rotasAtualizadas,
            }
          })
        }
      },

      onSalvar(customer, rotas) {
        const rotasSelecionadas = (rotas || []).filter(rota => rota.selected)

        if (!customer || rotasSelecionadas.length === 0)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione uma rota para Salvar',
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
        else if (rotasSelecionadas.length > 1)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'É possível associar apenas uma rota por Cliente',
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
        else
          setState(prevState => ({
            ...prevState,
            rotaSelecionada: rotasSelecionadas[0].rota_id,
            loadingMessage: LOAD_MESSAGE.SAVE_ROUTE,
          }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
